import React, { useRef, useEffect, useState, useCallback } from 'react';
import { FiCheck } from 'react-icons/fi';
import toast from 'react-hot-toast';
import { Button } from 'takeat-design-system-ui-kit';
import api from '../../services/api';
import BuyerObservationInput from './BuyerObservationInput';
import { Wrapper } from './styles';

const BuyerObservation = ({ buyer_id, readOnly = false, width = '110mm', minHeight = '80px' }) => {
  const inputRef = useRef(null);
  const [defaultValue, setDefaultValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);

  const fetchObservation = useCallback(async () => {
    try {
      const { data } = await api.get(`/restaurants/buyer-observation/${buyer_id}`);
      if (data?.observation) {
        setDefaultValue(data.observation);
      }
    } catch (err) {
      console.error('Erro ao buscar observação:', err);
    } finally {
      setFetched(true);
    }
  }, [buyer_id]);

  useEffect(() => {
    if (buyer_id) fetchObservation();
  }, [buyer_id, fetchObservation]);

  const handleSubmit = async () => {
    const observation = (inputRef.current?.getValue() || '').trim();
    setLoading(true);
    try {
      await api.put(`/restaurants/buyer-observation/${buyer_id}`, { observation });
      toast.success('Observação salva com sucesso!');
      if (inputRef.current) {
        inputRef.current.resetModified();
      }
    } catch (err) {
      toast.error('Erro ao salvar observação.');
    } finally {
      setLoading(false);
    }
  };

  if (readOnly && fetched && !defaultValue) return null;

  return (
    <Wrapper width={width}>
      <BuyerObservationInput ref={inputRef} defaultValue={defaultValue} onSave={handleSubmit} loading={loading} readOnly={readOnly} minHeight={minHeight} />
    </Wrapper>
  );
};

export default BuyerObservation;
